let scrollContainer = document.scrollingElement || document.documentElement;
let scrollTop = null;
let originalStyles = null;
let scrollLocked = false;

const disableScroll = () => {
  scrollLocked = true;
  scrollTop = scrollContainer.scrollTop;
  originalStyles = document.body.style.cssText;
  return document.body.style.cssText = `; overflow: hidden; position: fixed; height: 100%; width: 100%; top: ${-scrollTop}px; `;
};

const enableScroll = () => {
  scrollLocked = false;
  document.body.style.cssText = originalStyles;
  return scrollContainer.scrollTop = scrollTop;
};

export default {
  toggle: () => scrollLocked ? enableScroll() : disableScroll(),
  disableScroll,
  enableScroll
};
